import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import "../../assets/css/auth.css";
import "../../assets/css/common.css";
import { Typography, Box, CircularProgress } from "@material-ui/core";

function IntegrateWithApp() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = React.useState(true);
  // let param = {
  //   email: '',
  //   accessToken: ''
  // }

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const decodeParam = (key) => {
      const rawValue = params.get(key);
      return rawValue ? decodeURIComponent(rawValue) : "";
    };
    const email = decodeParam("email");
    const reportId = decodeParam("reportId");
    const accessToken = decodeParam("accessToken");
    const normalizedReportId = reportId.trim().toLowerCase();
    const hasReportId =
      normalizedReportId &&
      normalizedReportId !== "null" &&
      normalizedReportId !== "undefined";
    // param.email = email;
    // param.accessToken = accessToken;
    localStorage.setItem("0xaccountId", email);
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("accessSource", "app");

    //alert(reportId);

    const isMrr = reportId.trim().toUpperCase().startsWith("MRR");

    if (hasReportId) {
      if (accessToken) {
        if (isMrr) {
          history.replace("/report", { email, reportId });
        } else {
          history.replace("/myreport", { email, reportId });
        }
      }
    } else {
      if (accessToken) {
        history.replace("/myreports", {
          email,
          name: localStorage.getItem("0xuserId"),
        });
      }
    }
  }, []);

  return loading ? (
    <>
      <Box display="flex" flexDirection={"column"}>
        <div className="progress">
          <CircularProgress />
        </div>
        <div className="s20"></div>
        <Typography variant={"body1"}>Loading ..</Typography>
      </Box>
    </>
  ) : (
    <></>
  );
}

export default IntegrateWithApp;
